import { render } from "./CollectionDiff.vue?vue&type=template&id=0d036ea8"
import script from "./CollectionDiff.vue?vue&type=script&lang=js"
export * from "./CollectionDiff.vue?vue&type=script&lang=js"

import "./CollectionDiff.vue?vue&type=style&index=0&id=0d036ea8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__